import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MiscellaneousModule } from '@app/modules/common/miscellaneous.module';
import { SharedComponentModule } from '@app/components/shared/shared-component.module';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidenavbarComponent } from './sidenavbar/sidenavbar.component';
import { HelpComponent } from './help/help.component';
import { GlobalSearchResultComponent } from './global-search-result/global-search-result.component';
import { SearchResultTableComponent } from './global-search-result/search-result-table/search-result-table.component';

export const layoutComponent = [
  HeaderComponent,
  FooterComponent,
  SidenavbarComponent,
  HelpComponent,
  GlobalSearchResultComponent,
  SearchResultTableComponent
];

@NgModule({
  imports: [
    MiscellaneousModule,
    SharedComponentModule,
  ],
  declarations: [...layoutComponent],
  exports: [...layoutComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class LayoutModule { }
